      
<template>
    <div>
        <h2>OAuth Callback</h2>
        <div v-if="loading">
        <p>Loading...</p>
        </div>
        <div v-else>
            <p v-if="successMessage"> {{ successMessage }}</p>
        <p v-else-if="errorMessage">{{ errorMessage }}</p>
        </div>
    </div>
</template>
  
<script setup>
  import { ref, watch } from 'vue';
  import axios from 'axios';
  import { useErrorHandling } from '../composables/errorHandling';
  import { useToken } from '../composables/useToken';
  import { useRoute, useRouter } from 'vue-router';
  
  const { handleApiError } = useErrorHandling();
  const { GetToken } = useToken();
  const route = useRoute();
  const router = useRouter();
  
  const loading = ref(true);
  const successMessage = ref('');
  const errorMessage = ref('');
  
  const ProcessCallback = async () =>
  {
    loading.value = true;
    
    try
    {
        const authCode = route.query;
        if (!authCode)
        {
            errorMessage.value = "No authorization code was provided.";
            loading.value = false;
            return;
        }

        const data = {
            SessionToken: GetToken(),
            code: route.query.code,
            state: route.query.state,
            realmId: route.query.realmId,
            url: window.location.href,
        };

        const endpoint = `${process.env.VUE_APP_BASE_URL}/qbo/callback`;

        const response = await axios.post(endpoint, data)
        .then(response => {
        return response.status === 201;
        })
        .catch(error => {
        handleApiError(error);
        });

        if (response === true)
        {
            successMessage.value = "Successfully connected to Quickbooks Online. Redirecting in 3 seconds, please hold on.";
            setTimeout(() => {
                router.push('/orders');
            }, 3000);
        }
        else
        {
            errorMessage.value = "Could not retrieve token.";
        }
    }
    catch (error)
    {
        console.log('error', error);
        errorMessage.value = "An unexpected error occured. Please try again.";
        handleApiError(error.message);
    }
    finally
    {
        loading.value = false;
    }
  }
  
watch(
    () => route.query,
    () => {
    ProcessCallback();
    },
    { immediate: true }
);
</script>  